module.exports = __webpack_public_path__ + "images/card-unknown.4c28510b4a20aa664d5843e64c7d9cde.svg";